export default __webpack_public_path__ + "static/daylon-bitmoji-58f0591082f22e3969e74452595d3ed6.png";